<!--订单发起采购页面-->
<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true" :destroy-on-close="true"
    custom-class="pay-dialog">
    <iframe :src="iframeurl" class="framestyle" frameborder="0" scrolling="no" name="ssowebframe"></iframe>
  </el-dialog>
</template>

<script>

  export default {
    name: 'BuyfromSupplyer',
    data() {
      return {
        title: '确认付款',
        iframeurl: "",
        dialogSeeVisible:false,
      }
    },
    methods: {
      afterClose() {
        try {
          this.$emit("afterClose");
        } catch (e) {
        }
      },
      show(ssotoken, website, item, type) {
        var obj=this;
        this.dialogSeeVisible = true;
        window.closeBuyDialog = function(){
          obj.dialogSeeVisible=false;
          obj.afterClose();
        }
        if (ssotoken && ssotoken.indexOf('TZYJ：') == 0) {
          ssotoken = ssotoken.replace('TZYJ：', '')
        }
        switch (type) {
          case 'pay':
            this.title = '确认付款'
            this.iframeurl = "//" + website + "/H5/ssologin.html?token=" + ssotoken +
              "&redirecturl=html/gouWuChe/fuKuan.html^inframe=1*groupguid=" + item.groupguid+'*backurl=//' + window.location.host + '/static/close.html';
            break;
          case 'detail':
            this.title = '查看订单'
            this.iframeurl = "//" + website + "/H5/ssologin.html?token=" + ssotoken +
              "&redirecturl=html/dingDan/chaKanMingXi.html^inframe=1*erpserial=" + item.erpserial;
            break;
          case 'back':
            this.title = '退单'
            this.iframeurl = "//" + website + "/H5/ssologin.html?token=" + ssotoken +
              "&redirecturl=html/dingDan/tuiKuan.html^inframe=1*uguid=" + item.unitguid + "*alreadyPaid=0*status=" + item.status + "*erpserial=" + item.erpserial+'*backurl=//' + window.location.host + '/static/close.html';
            break;
        }
        //this.iframeurl = "http://" + window.location.host + "/static/close.html";
      },
    },
    mounted() {

    },
    components: {
    }
  }
</script>

<style scoped>
  .framestyle {
    width: 100%;
    border: 0px;
    height: calc(100vh - 110px);
    background-size: 100% 100%;
    margin: 0px;
    padding: 0px;
  }
</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyfromSupplyer.vue